
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'text',
        field: 'email',
        label: 'Email',
        maxlength: 500,
        info: 'Digite apenas um ou mais emails separados por ; (ponto e vírgula)',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-tipo',
        field: 'tipo',
        tipo: 32,
        label: 'Setor (Tipo de Email)',
        multiple: true,
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'fdt',
        label: 'Frente de Trabalho',
        option: {
            key: 'id',
            label: 'fdt',
            value: 'id'
        },
        multiple: true,
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'boolean',
        field: 'ativo',
        label: 'Ativo',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-12',
        type: 'textarea',
        field: 'obs',
        label: 'Observações',
        info: '',
        rules: ['']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/empresa/meu-cadastro/_form/meu-cadastro-email.js